import { ShieldAlert, MapPin, EyeOff, Mail } from "lucide-react";

const refCode = `SEC-${Date.now().toString(36).toUpperCase()}`;

export default function SecurityAlert() {
  return (
    <div className="relative overflow-hidden rounded-xl border border-red-500/40 bg-[#0B1220] text-left shadow-[0_10px_40px_rgba(220,38,38,0.25)]" data-testid="security-alert">
      <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-red-600 via-red-400 to-red-600" />
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-red-600/10 blur-2xl pointer-events-none" />

      <div className="px-5 pt-5 pb-4 flex items-center gap-3 border-b border-white/10">
        <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-500/15 border border-red-500/40">
          <ShieldAlert size={16} className="text-red-400" />
          <span className="absolute -top-1 -right-1 flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
          </span>
        </span>
        <div>
          <div className="font-mono-tech text-[11px] tracking-[0.25em] font-semibold text-red-400">ALERTA DE SEGURIDAD</div>
          <div className="font-mono-tech text-[9px] tracking-widest text-slate-500">PROTOCOLO DE PROTECCIÓN · REG {refCode}</div>
        </div>
      </div>

      <div className="px-5 py-4 space-y-3">
        <p className="text-[11px] leading-relaxed text-slate-300">
          Se ha generado una alerta de seguridad y se ha <span className="text-white font-semibold">notificado automáticamente
          al administrador del sistema</span>.
        </p>

        <div className="flex gap-2.5 rounded-lg bg-white/[0.04] border border-white/10 px-3 py-2.5">
          <MapPin size={13} className="text-red-400 shrink-0 mt-0.5" />
          <p className="text-[11px] leading-relaxed text-slate-400">
            Su dirección IP podría ser incluida en una <span className="text-red-400">lista de bloqueo</span>, lo que impediría
            futuros accesos a este sitio web. Asimismo, los sistemas de seguridad podrían detectar la ubicación geográfica
            asociada a dicho acceso y aplicar restricciones adicionales desde esa zona geográfica.
          </p>
        </div>

        <div className="flex gap-2.5 rounded-lg bg-white/[0.04] border border-white/10 px-3 py-2.5">
          <EyeOff size={13} className="text-red-400 shrink-0 mt-0.5" />
          <p className="text-[11px] leading-relaxed text-slate-400">
            Si está utilizando un servicio <span className="text-slate-200">VPN, proxy o cualquier sistema de ocultación de
            ubicación</span>, le recomendamos desactivarlo e intentar acceder nuevamente al sistema, ya que este tipo de
            conexiones pueden ser identificadas como potencialmente sospechosas y provocar restricciones de acceso.
          </p>
        </div>
      </div>

      <div className="px-5 py-3 border-t border-white/10 flex items-center gap-2">
        <Mail size={11} className="text-slate-500 shrink-0" />
        <p className="font-mono-tech text-[9px] tracking-wider text-slate-500">
          SI CONSIDERA QUE ESTA ALERTA HA SIDO GENERADA POR ERROR, CONTACTE CON SU ADMINISTRADOR DEL SISTEMA.
        </p>
      </div>
    </div>
  );
}
